document.addEventListener("DOMContentLoaded", function () {
  // Load jQuery from CDN (example)
  var script = document.createElement("script");
  script.src = "https://code.jquery.com/jquery-3.6.0.min.js"; // Replace with your jQuery version or local path
  script.onload = function () {
    // jQuery is now loaded, you can use it

    /*重复触发，注释掉
    jQuery('.ajax-spin-cart').click(async function (e) {
      e.preventDefault();
      await Shopify.addItemFromForm('add-item-form');
    });
  };
  document.head.appendChild(script);
  */

    // Create modal
    var modal = document.createElement("div");
    modal.id = "specModal";
    modal.classList.add("modal");
    modal.innerHTML = `
    <div class="modal-content">
      <h2 class="modal-title"></h2>
      <span class="close">&times;</span>
      <div class="modal-body"></div>
      <button type="submit" class="btn btn-style1 add-to-cart ajax-spin-cart" id="AddToCart" style=" position: fixed;
     bottom:0px; z-index: 999999999999999999999;width:full;left:0px;right:0px;">
         <span class="cart-title" id="AddToCartText">Add to Cart - <span class="add-to-cart-product-price1">$0.00</span></span>
        <span class="cart-loading animated infinite rotateOut">
          <i class="ion-load-a"></i>
        </span>
        <span class="cart-added">
          <i class="ion-android-done"></i>
        </span>
        <span class="cart-unavailable"></span>
        <div class="sp-validate-overlay" style="position: absolute; display: block; z-index: 100000; cursor: pointer; inset: 0px;"></div>
      </button>
    </div>
  `;
    document.body.appendChild(modal);

    var closeModalBtn = modal.querySelector(".close");
    var modalTitle = modal.querySelector(".modal-title");
    var modalBody = modal.querySelector(".modal-body");

    // Function to copy content to modal and show it
    function showModal(detailsElement) {
      var accordionContent = detailsElement.querySelector(
        ".accordion__content"
      ).innerHTML;
      var accordionTitle =
        detailsElement.querySelector(".accordion__title").innerText;
      var productPrice = document.getElementById("ProductPrice").innerText;
      document.querySelector(".add-to-cart-product-price1").innerText =
        productPrice;

      modalBody.innerHTML = accordionContent;
      modalTitle.innerText = accordionTitle;
      modal.style.display = "block";
      modal.querySelector(".mobile-cart-action").classList.remove("hidden");
    }

    // Handle details toggle event on mobile
    var detailsElements = document.querySelectorAll(
      ".product__accordion details"
    );
    detailsElements.forEach(function (detailsElement) {
      detailsElement.addEventListener("toggle", function (event) {
        if (window.innerWidth <= 767 && detailsElement.hasAttribute("open")) {
          event.preventDefault(); // Prevent default behavior
          detailsElement.removeAttribute("open"); // Close the details element
          showModal(detailsElement); // Show modal with content
        }
      });
    });

    // Close modal functionality
    closeModalBtn.addEventListener("click", function () {
      modal.style.display = "none";
      modal.querySelector(".mobile-cart-action").classList.add("hidden");
    });

    window.addEventListener("click", function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    });
  };
});



var DiscountCountdown = class extends HTMLElement {
  constructor() {
    super();
    this._endingTime = this.getAttribute("data-ending_time");
    this._dateEl = this.querySelector(".countdown__item.day>span");
    this._hourEl = this.querySelector(".countdown__item.hour>span");
    this._minuteEl = this.querySelector(".countdown__item.minute>span");
    this._secondsEl = this.querySelector(".countdown__item.seconds>span");
    this._countdownIntervalFunction = this._handleCountdown.bind(this);
  }
  connectedCallback() {
    this._interval = setInterval(this._countdownIntervalFunction, 1000);
  }
  disconnectedCallback() {
    clearInterval(this._interval);
  }
  _formatNumber(num) {
    if(num < 10) {
      return `0${num}`;
    } else {
      return num;
    }
  }
  _handleCountdown() {
    // 获取目标时间
    // const targetTime = new Date(this._endingTime).getTime();
    const targetTime = new Date(this._endingTime).getTime()
    // 获取当前时间
    const currentTime = new Date().getTime();
    // 获取时间差
    const diffTime = targetTime - currentTime;
    if (diffTime <= 0) {
      // 置零
      this._dateEl.html("00");
      this._hourEl.html("00");
      this._minuteEl.html("00");
      this._secondsEl.html("00");
      return;
    }
    // 计算时间差day
    const day = Math.floor(diffTime / 86400000);
    const dayRemain = Math.floor(diffTime % 86400000);
    // 计算小时数
    const hours = Math.floor(dayRemain / 3600000);
    const hoursRemain = Math.floor(dayRemain % 3600000);
    // 计算分钟数
    const minutes = Math.floor(hoursRemain / 60000);
    const minutesRemain = Math.floor(hoursRemain % 60000);
    // 计算秒数
    const seconds = Math.floor(minutesRemain / 1000);
    // 更新
    this._dateEl.innerHTML = this._formatNumber(day);
    this._hourEl.innerHTML = this._formatNumber(hours);
    this._minuteEl.innerHTML = this._formatNumber(minutes);
    this._secondsEl.innerHTML = this._formatNumber(seconds);
  }
};
if (!window.customElements.get("discount-countdown")) {
  window.customElements.define("discount-countdown", DiscountCountdown);
}